import { NgxMaskConfig } from 'ngx-mask';
import { inject } from '@angular/core';
import { THOUSAND_SEPARATOR } from '@data-terminal/data-access/injection-tokens';

export function createMaskConfig(): Partial<NgxMaskConfig> {
    const thousandSeparator = inject(THOUSAND_SEPARATOR);
    return {
        thousandSeparator,
    };
}
